/* global Provider */
import React, { Component } from 'react';
import GlideChart from './GlideChart';
import RiskChart from './RiskChart';
import Step from './Step';
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

export default class GlideStep extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filename: null,
            tabIndex: 0
        }

        this.getReportFormContent = this.getReportFormContent.bind(this);
        this.showReport = this.showReport.bind(this);

        this.preparedForRef = React.createRef();
        this.preparedByRef = React.createRef();
        this.logoNameRef = React.createRef();
        this.adviserLogoNameRef = React.createRef();
        this.commentsRef = React.createRef();
        this.portraitRef = React.createRef();
        this.summaryRef = React.createRef();
        this.quartilesRef = React.createRef();
        this.glidePathRef = React.createRef();
        this.glideOptimizedRef = React.createRef();
        this.tabRef = React.createRef();
    }

    showReport(includeMethodology) {
        //if (Provider.isDebug()){
        //    Provider.showReport('DEF Company', 'Jared\nShockcor', includeMethodology);
        //}else{
        let content = this.getReportFormContent();
        Provider.showModal('Personalize Your Report', content, 'personalize-modal modal-lg', () => {
            let pf = this.validateField(this.preparedForRef.current);
            let pb = this.validateField(this.preparedByRef.current);
            if (!pf || (!pb && !this.props.adviserLogo)) return false;

            let comments = this.commentsRef.current.value || null;
            let portrait = this.portraitRef.current.checked || false;
            let summary = this.summaryRef.current.checked || false;
            let quartiles = this.quartilesRef.current.checked || false;
            let glidePath = this.glidePathRef.current.checked || false;
            let glideOptimized = this.glideOptimizedRef.current.checked || false;

            Provider.showReport(pf, pb, includeMethodology, comments, portrait, summary, quartiles,glidePath,glideOptimized);
            Provider.submitAciData('personalization completed', includeMethodology);
            return true;
        }, 'Generate Report', null, true);
        //}
    }

    validateField(fld) {
        let val = fld.value.replace(/[^a-zA-Z0-9\-$_,?!&%+#'()\s\n]+/g, "").slice(0, 1000).trim();

        if (!val) {
            fld.classList.add('is-invalid');
            return null;
        } else {
            fld.classList.remove('is-invalid');
            return val;
        }
    }

    getReportFormContent() {
        return (
            <div>
                <div className="form-group">
                    <label>Prepared For:</label>
                    <textarea className="form-control form-control-sm" ref={this.preparedForRef} rows="2" defaultValue={this.props.responses['name'] || this.props.preparedFor || ''} />
                </div>
                <div className="form-group">
                    <label>Prepared For Logo:</label>
                    <div className="custom-file form-control-sm">
                        <input type="file" className="custom-file-input" id="customFile" accept=".jpg,.jpeg,.png,.gif" onChange={(event) => {
                            try {
                                var file = event.target.files[0];
                                if (!file) return;
                                try {
                                    this.logoNameRef.current.innerHTML = file.name;
                                } catch (ee) { }
                                var fr = new FileReader();
                                fr.onload = (event) => {
                                    let logo = event.target.result;
                                    if (!logo) return;
                                    Provider.setLogo(logo, file.name);
                                };
                                fr.readAsDataURL(file);
                            } catch (e) { }
                        }} />
                        <label className="custom-file-label" htmlFor="customFile" ref={this.logoNameRef}>{this.props.logoName || 'Choose file'}</label>
                    </div>

                    <small className="d-block mt-1 text-muted">File must be in format .jpg, .png, or .gif. Suggested dimensions are 400px by 300px.</small>
                </div>
                <div className="form-group">
                    <label>Prepared By:</label>
                    <textarea className="form-control form-control-sm" ref={this.preparedByRef} rows="2" defaultValue={this.props.preparedBy || ''} />
                </div>
                <div className="form-group">
                    <label>Prepared By Logo:</label>
                    <div className="custom-file form-control-sm">
                        <input type="file" className="custom-file-input" id="customFile" accept=".jpg,.jpeg,.png,.gif" onChange={(event) => {
                            try {
                                var file = event.target.files[0];
                                if (!file) return;
                                try {
                                    this.adviserLogoNameRef.current.innerHTML = file.name;
                                } catch (ee) { }
                                var fr = new FileReader();
                                fr.onload = (event) => {
                                    let logo = event.target.result;
                                    if (!logo) return;
                                    Provider.setAdviserLogo(logo, file.name);
                                };
                                fr.readAsDataURL(file);
                            } catch (e) { }
                        }} />
                        <label className="custom-file-label" htmlFor="customFile" ref={this.adviserLogoNameRef}>{this.props.adviserLogoName || 'Choose file'}</label>
                    </div>

                    <small className="d-block mt-1 text-muted">File must be in format .jpg, .png, or .gif. Suggested dimensions are 150px by 75px.</small>
                </div>
                <div className="form-group">
                    <label>Page Orientation</label>
                    <div className="form-check">
                        <input class="form-check-input" type="radio" name="portrait" id="portrait" defaultChecked={true} ref={this.portraitRef} /><label className="form-check-label" for="portrait"> Portrait</label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="portrait" id="landscape" /><label className="form-check-label" for="landscape"> Landscape</label>
                    </div>
                </div>
                <div className="form-group">
                    <label>Add summary page of participant and target-date characteristics</label>
                    <input type="checkbox" className="form-control" ref={this.summaryRef} defaultChecked={true} />
                </div>
                <div className="form-group">
                    <label>Substitute fund scoring for quartiles ranking</label>
                    <input type="checkbox" className="form-control" ref={this.quartilesRef} defaultChecked={false} />
                </div>
                <div className="form-group">
                    <label>Add glide path comparison</label>
                    <input type="checkbox" className="form-control" ref={this.glidePathRef} defaultChecked={true} />
                </div>
                <div className="form-group">
                    <label>Add the optimized glide path comparison</label>
                    <input type="checkbox" className="form-control" ref={this.glideOptimizedRef} defaultChecked={true} />
                </div>
                <div className="form-group">
                    <label>Additional Comments:</label>
                    <textarea className="form-control form-control-sm" ref={this.commentsRef} rows="15" defaultValue={this.props.comments || ''} />
                </div>
            </div>
        );
    }

    render() {
        let { tabIndex } = this.state
        return (
            <Step className={this.props.className}>
                <h1>Glide Path Comparison</h1>
                <div>
                    {/* <div className="text-center mb-4 alert alert-fair">
                        <h4>Generate a Target-Date Blueprint Report</h4>
                        <div className="d-block">
                            <button className="mr-1 btn btn-sm btn-primary" onClick={() => { this.showReport(false) }}>Report Only</button>
                            <button className="btn btn-sm btn-primary" onClick={() => { this.showReport(true) }}>Report and Methodology</button>
                        </div>
                    </div> */}
                    <div className='row justity-center'>
                        <Tabs
                            value={tabIndex}
                            textColor="primary"
                            indicatorColor="primary"
                            onChange={(event, newValue) => {
                                this.setState({
                                    tabIndex: newValue
                                });
                            }}
                        >
                            <Tab label="Glide Path Comparison" />
                            <Tab label="Optimal Glide Path for Savings/Risk Profile" />
                        </Tabs>
                    </div>
                    <GlideChart showOptimal={tabIndex == 0 ?false: true}/>


                    {tabIndex > 0 &&
                            <p className="glideNote">Optimal Glide Path for savings/risk profile based on original research described in 
                            "On Optimal Allocations of Target-Date Funds" by Radu Gabudean, Francisco Gomes, Alexander Michaelides, and Yuxin 
                            Zhang appears in the Fall 2021 issue of The Journal of Retirement, © 2021, PMR. All rights reserved. 
                             <a className='alink' target='_blank' href='https://www.pm-research.com/'>https://www.pm-research.com/</a>  Link to paper: <a className='alink' href='https://www.americancentury.com/insights/optimal-glide-paths-new-research' target='_blank'>https://www.americancentury.com/insights/optimal-glide-paths-new-research</a>
                             </p>        
                        }

                   
                    {/* <div className="mt-4 text-center alert alert-fair">
                        <h4>Generate a Target-Date Blueprint Report</h4>
                        <div className="d-block">
                            <button className="mr-1 btn btn-sm btn-primary" onClick={() => { this.showReport(false) }}>Report Only</button>
                            <button className="btn btn-sm btn-primary" onClick={() => { this.showReport(true) }}>Report and Methodology</button>
                        </div>
                        <small className="d-block mt-2 text-center">
                            It’s important to compare fees, expenses, performance and risk metrics after determining suitability.
                        </small>
                        <small className="d-block mt-2 text-center">
                            A detailed analysis around risk can be obtained through the Target Date Risk Dashboard available on the homepage for this tool.
                        </small>
                    </div> */}
                </div>
            </Step>
        );
    }
}
